import {
  CorrespondantDto,
  IUtilisateurPreferencesWebServiceClient,
  LigneCatalogueExamenLightDto,
  RechercheDossierDto,
  UtilisateurPreferencesDto
} from "@resources/resources";
import { ActivatedRoute } from "@angular/router";
import { TranslateService } from "@ngx-translate/core";
import { FiltreItem, FiltreItems } from "./vos-filtres/filtre-item";
import { Component, EventEmitter, Output } from "@angular/core";
import { FormBuilder, FormGroup } from "@angular/forms";
import { MomentService, NotificationService, CorrespondantStore } from "@digicerba/common";
import { ViewChild } from '@angular/core';
import { AsiSelectComponent } from "@asi-ngtools/lib";

import {Router} from "@angular/router";
import * as lodash from "lodash";
import {debounceTime} from "rxjs/operator/debounceTime";

@Component({
  selector: 'serveur-resultats-filtres',
  templateUrl: './serveur-resultats-filtres.component.html',
  host: { 'class': 'filter' }
})
export class ServeurResultatsFiltresComponent {

  filterForm: FormGroup;

  @ViewChild("laboratoiresComponent")
  laboratoiresComponent: AsiSelectComponent;

  @ViewChild("medecinsComponent")
  medecinsComponent: AsiSelectComponent;

  @Output() onFiltering = new EventEmitter<RechercheDossierDto>();

  //Ensemble des filtre possible
  filtres = new Array<FiltreItems>();
  //Filtre selectionneee
  filtre: FiltreItems;

  laboratoires = new Array<CorrespondantDto>();
  medecins = new Array<CorrespondantDto>();

  examens = new Array<any>();

  baseExamens: Array<LigneCatalogueExamenLightDto>;

  utilisateurPreferencesDto: UtilisateurPreferencesDto;
  debounceTime: number = 500;

  constructor(private formBuilder: FormBuilder, private activateRoute: ActivatedRoute,
    private correspondantStore: CorrespondantStore,
    private translateService: TranslateService,
    private notificationService: NotificationService,
    private utilisateurPreferences: IUtilisateurPreferencesWebServiceClient,
    private momentService: MomentService,
    private router: Router) {
    this.initForm();
  }

  ngOnInit() {

    this.laboratoires = this.correspondantStore.getCorrespondants().filter(
      c => !c.tags || !(c.tags.indexOf('SRV-resultat-medecin') >= 0)
    );

    this.medecins = this.correspondantStore.getCorrespondants().filter(
      c => !c.tags || !(c.tags.indexOf('SRV-resultat-labo') >= 0)
    );

    if (this.laboratoires.length == 1) {
      this.filterForm.value.laboratoires = this.laboratoires[0];
    }

    if (this.medecins.length == 1) {
      this.filterForm.value.medecins = this.medecins[0];
    }

    this.activateRoute.data.subscribe((data) => {
      const emissionHprimDebounce = data['emissionHprimDebounceExamen'];
      this.baseExamens = emissionHprimDebounce.examens;
    });

    this.utilisateurPreferencesDto = this.activateRoute.snapshot.data['utilisateurPreferences'];

    if (this.utilisateurPreferencesDto == null) {
      this.utilisateurPreferencesDto = new UtilisateurPreferencesDto();

      this.utilisateurPreferencesDto.page = 'SERVEUR_RESULTATS';
      this.utilisateurPreferencesDto.type = 'FILTRES';
      this.filtres = new Array<FiltreItems>();
      this.utilisateurPreferencesDto.preferences = this.filtres;
    } else {
      this.filtres = this.utilisateurPreferencesDto.preferences;
    }
  }

  initForm() {
    this.filterForm = this.formBuilder.group({
      dossierNomPrenom: null,
      laboratoires: null,
      medecins: null,
      examens: null,
      dateNaissance: null,
      debutDateCreation: null,
      finDateCreation: null,
      urgent: null,
      pathologique: null,
      termine: null,
      partiels: null,
      notdownloaded: null
    });

    this.activateRoute.data.subscribe(data => {
      const emissionHprimDebounce = data['emissionHprimDebounceExamen'];
      this.debounceTime = emissionHprimDebounce.debounceDelay;
    });

    if(this.router && this.router.url){
      let baseUrl = this.router.parseUrl(this.router.url)
      if(baseUrl && baseUrl.queryParams && baseUrl.queryParams["notDownloadedFilter"] === "true"){
        this.filterForm.controls.notdownloaded.setValue(true);
        lodash.debounce(() => {
          this.submit();
        }, this.debounceTime)();
      }
    }

    this.filterForm.controls.dossierNomPrenom.valueChanges.debounceTime(this.debounceTime).subscribe(() => {
      this.submit();
    });
  }

  submit() {
    // Le composant n'existe pas s'il n'y zero ou qu'un seul laboratoire !
    if (this.laboratoiresComponent && this.laboratoiresComponent.isOpened()) {
      this.laboratoiresComponent.toggleSelect();
    }

    // Le composant n'existe pas s'il n'y zero ou qu'un seul médecin !
    if (this.medecinsComponent && this.medecinsComponent.isOpened()) {
      this.medecinsComponent.toggleSelect();
    }

    let rechercheDossierDto = this.initRechercheDto();
    this.manageFilter();
    this.onFiltering.emit(rechercheDossierDto);
  }

  initRechercheDto(): RechercheDossierDto {
    let formValues = this.filterForm.value;
    let rechercheDossierDto = new RechercheDossierDto();
    rechercheDossierDto.dossierNomPrenom = formValues.dossierNomPrenom;
    if (formValues.dateNaissance != null) {
      rechercheDossierDto.jourNaissance = formValues.dateNaissance.day;
      rechercheDossierDto.moisNaissance = formValues.dateNaissance.month;
      rechercheDossierDto.anneeNaissance = formValues.dateNaissance.year;
    }
    rechercheDossierDto.debutDateCreation = this.momentService.formatToLocalDate(formValues.debutDateCreation);
    rechercheDossierDto.finDateCreation = this.momentService.formatToLocalDate(formValues.finDateCreation);
    rechercheDossierDto.laboratoires = formValues.laboratoires;
    rechercheDossierDto.medecins = formValues.medecins;
    rechercheDossierDto.examens = formValues.examens;

    //Gestion de l'etat
    rechercheDossierDto.etats = [];
    if (formValues.urgent) {
      rechercheDossierDto.etats.push('URGENT');
    }
    if (formValues.pathologique) {
      rechercheDossierDto.etats.push('PATHOLOGIQUE');
    }

    //Gestion du status
    rechercheDossierDto.status = [];
    if (formValues.termine) {
      rechercheDossierDto.status.push('TERMINE');
    }
    if (formValues.partiels) {
      rechercheDossierDto.status.push('VALIDE_PARTIEL');
    }

    //Gestion du non téléchargement
    rechercheDossierDto.notDownloaded = formValues.notdownloaded;

    //Gestion des laboratoires
    rechercheDossierDto.laboratoiresTotal = this.laboratoires;
    rechercheDossierDto.medecinsTotal = this.medecins;

    return rechercheDossierDto;
  }

  manageFilter() {
    const myFiltre = new FiltreItems;
    const filters = new Array<FiltreItem>();

    myFiltre.name = (this.filtre != null) && this.filtre.name || '';
    myFiltre.filtres = filters;

    const formValues = this.filterForm.value;

    if (formValues.dossierNomPrenom != null) {
      filters.push(new FiltreItem("NOM", formValues.dossierNomPrenom, formValues.dossierNomPrenom))
    }
    if (formValues.dateNaissance != null) {
      if (formValues.dateNaissance.day != null) {
        filters.push(new FiltreItem("JOUR_NAISSANCE", "PAGE.SERVEUR-RESULTATS.FILTRE-BADGE.day", formValues.dateNaissance.day));
      }
      if (formValues.dateNaissance.month != null) {
        filters.push(new FiltreItem("MOIS_NAISSANCE", "PAGE.SERVEUR-RESULTATS.FILTRE-BADGE.month", formValues.dateNaissance.month));
      }
      if (formValues.dateNaissance.year != null) {
        filters.push(new FiltreItem("ANNEE_NAISSANCE", "PAGE.SERVEUR-RESULTATS.FILTRE-BADGE.year", formValues.dateNaissance.year));
      }
    }
    if (formValues.debutDateCreation != null) {
      const libelleDebut = this.translateService.instant("PAGE.SERVEUR-RESULTATS.FILTRE-BADGE.debutDateCreation") + this.momentService.formatDateTime(formValues.debutDateCreation);
      filters.push(new FiltreItem("DEBUT_DATE_CREATION", libelleDebut, formValues.debutDateCreation));
    }
    if (formValues.finDateCreation != null) {
      const libelleFin = this.translateService.instant("PAGE.SERVEUR-RESULTATS.FILTRE-BADGE.finDateCreation") + this.momentService.formatDateTime(formValues.finDateCreation);
      filters.push(new FiltreItem("FIN_DATE_CREATION", libelleFin, formValues.finDateCreation));
    }
    if (formValues.laboratoires != null) {
      const filtresLabo = new FiltreItem("LABORATOIRES", "PAGE.SERVEUR-RESULTATS.FILTRE-BADGE.laboratoire", formValues.laboratoires);
      filtresLabo.multiple = true;
      filters.push(filtresLabo);
    }
    if (formValues.medecins != null) {
      const filtresMed = new FiltreItem("MEDECINS", "PAGE.SERVEUR-RESULTATS.FILTRE-BADGE.medecin", formValues.medecins);
      filtresMed.multiple = true;
      filters.push(filtresMed);
    }
    if (formValues.examens != null) {
      const filtresExamens = new FiltreItem("EXAMENS", "PAGE.SERVEUR-RESULTATS.FILTRE-BADGE.examen", formValues.examens);
      filtresExamens.multiple = true;
      filters.push(filtresExamens);
    }
    if (formValues.urgent) {
      filters.push(new FiltreItem("URGENT", "PAGE.SERVEUR-RESULTATS.FILTRE-BADGE.urgent", formValues.urgent));
    }
    if (formValues.pathologique) {
      filters.push(new FiltreItem("PATHOLOGIE", "PAGE.SERVEUR-RESULTATS.FILTRE-BADGE.pathologique", formValues.pathologique));
    }
    if (formValues.termine) {
      filters.push(new FiltreItem("TERMINE", "PAGE.SERVEUR-RESULTATS.FILTRE-BADGE.termine", formValues.termine));
    }
    if (formValues.partiels) {
      filters.push(new FiltreItem("PARTIELS", "PAGE.SERVEUR-RESULTATS.FILTRE-BADGE.partiels", formValues.partiels));
    }
    if (formValues.notdownloaded) {
      filters.push(new FiltreItem("NOT-DOWNLOADED", "PAGE.SERVEUR-RESULTATS.FILTRE-BADGE.notdownloaded", formValues.notdownloaded));
    }
    this.filtre = myFiltre;
  }

  autoCompleteExamens(value: string) {
    this.examens = lodash.filter(this.baseExamens, ((examen) => {
      let compCode = lodash.deburr(examen.codeOpenlab);
      compCode = lodash.lowerCase(compCode);

      let compLibelle = lodash.deburr(examen.titre);
      compLibelle = lodash.lowerCase(compLibelle);

      value = lodash.deburr(value);
      value = lodash.lowerCase(value);

      return (compCode.indexOf(value) >= 0) || (compLibelle.indexOf(value) >= 0);
    }));
  }

  onFiltreRemoved(removedFiltre: FiltreItems) {
    this.filtres = [...lodash.filter(this.filtres, (filtre) => {
      return filtre.name != removedFiltre.name;
    })];
    this.utilisateurPreferencesDto.preferences = this.filtres;
    this.utilisateurPreferences.updateUserPreferences(this.utilisateurPreferencesDto).subscribe(() => {
      this.notificationService.showInfoNotification("PAGE.SERVEUR-RESULTATS.FILTRE.updated");
      this.filterForm.reset();
    });
  }

  onFiltreUpdated(output: any) {
    let existingFiltre = lodash.find(this.utilisateurPreferencesDto.preferences, (filtreItems: FiltreItems) => {
      return filtreItems.name === output.filtre.name;
    });
    existingFiltre.filtres = output.filtre.filtres;
    existingFiltre.name = output.name;

    this.utilisateurPreferences.updateUserPreferences(this.utilisateurPreferencesDto).subscribe(utilisateurPreferences => {
      this.utilisateurPreferencesDto = utilisateurPreferences;
      this.notificationService.showInfoNotification("PAGE.SERVEUR-RESULTATS.FILTRE.updated");
      this.filtres = this.utilisateurPreferencesDto.preferences;
      this.filtre = existingFiltre;
    });
  }

  onFiltreCreated(filtre: FiltreItems) {
    this.utilisateurPreferencesDto.preferences.push(filtre);

    this.utilisateurPreferences.createUserPreferences(this.utilisateurPreferencesDto).subscribe(utilisateurPreferences => {
      this.utilisateurPreferencesDto = utilisateurPreferences;
      this.notificationService.showInfoNotification("PAGE.SERVEUR-RESULTATS.FILTRE.saved");

      this.utilisateurPreferences.getUserPreferences('FILTRES', 'SERVEUR_RESULTATS').subscribe(utilisateurPreferences => {
        this.filtres = utilisateurPreferences.preferences;
        this.filtre = filtre;
      });
    });
  }

  onFiltreSelected(filtre: FiltreItems) {
    this.filtre = filtre;
    this.filterForm.reset();

    if (!filtre || !filtre.filtres) return;
    for (let aFiltre of this.filtre.filtres) {
      switch (aFiltre.code) {
        case "NOM": {
          this.filterForm.controls.dossierNomPrenom.setValue(aFiltre.value);
          break;
        }
        case "JOUR_NAISSANCE": {
          let dmy = this.filterForm.value.dateNaissance;
          if (dmy == null) {
            dmy = {
              day: null,
              month: null,
              year: null,
            }
          }
          dmy.day = aFiltre.value;
          this.filterForm.controls.dateNaissance.setValue(dmy);
          break;
        }
        case "MOIS_NAISSANCE": {
          let dmy = this.filterForm.value.dateNaissance;
          if (dmy == null) {
            dmy = {
              day: null,
              month: null,
              year: null,
            }
          }
          dmy.mois = aFiltre.value;
          this.filterForm.controls.dateNaissance.setValue(dmy);
          break;
        }
        case "ANNEE_NAISSANCE": {
          let dmy = this.filterForm.value.dateNaissance;
          if (dmy == null) {
            dmy = {
              day: null,
              month: null,
              year: null,
            }
          }
          dmy.annee = aFiltre.value;
          this.filterForm.controls.dateNaissance.setValue(dmy);
          break;
        }
        case "DEBUT_DATE_CREATION": {
          this.filterForm.controls.debutDateCreation.setValue(aFiltre.value);
          break;
        }
        case "FIN_DATE_CREATION": {
          this.filterForm.controls.finDateCreation.setValue(aFiltre.value);
          break;
        }
        case "LABORATOIRES": {
          this.filterForm.controls.laboratoires.setValue(aFiltre.value);
          break;
        }
        case "MEDECINS": {
          this.filterForm.controls.medecins.setValue(aFiltre.value);
          break;
        }
        case "EXAMENS": {
          this.filterForm.controls.examens.setValue(aFiltre.value);
          break;
        }
        case "URGENT": {
          this.filterForm.controls.urgent.setValue(aFiltre.value);
          break;
        }
        case "PATHOLOGIE": {
          this.filterForm.controls.pathologique.setValue(aFiltre.value);
          break;
        }
        case "TERMINE": {
          this.filterForm.controls.termine.setValue(aFiltre.value);
          break;
        }
        case "PARTIELS": {
          this.filterForm.controls.partiels.setValue(aFiltre.value);
          break;
        }
        case "NOT-DOWNLOADED": {
          this.filterForm.controls.notdownloaded.setValue(aFiltre.value);
          break;
        }
        default:
          throw "Illegal argument";
      }
    }
  }

  onFiltreItemRemoved(filtre: FiltreItem) {
    switch (filtre.code) {
      case "NOM": {
        this.filterForm.controls.dossierNomPrenom.setValue(null);
        break;
      }
      case "JOUR_NAISSANCE": {
        let dmy = this.filterForm.value.dateNaissance;
        dmy.day = null;
        this.filterForm.controls.dateNaissance.setValue(dmy);
        break;
      }
      case "MOIS_NAISSANCE": {
        let dmy = this.filterForm.value.dateNaissance;
        dmy.month = null;
        this.filterForm.controls.dateNaissance.setValue(dmy);
        break;
      }
      case "ANNEE_NAISSANCE": {
        let dmy = this.filterForm.value.dateNaissance;
        dmy.year = null;
        this.filterForm.controls.dateNaissance.setValue(dmy);
        break;
      }
      case "DEBUT_DATE_CREATION": {
        this.filterForm.controls.debutDateCreation.setValue(null);
        break;
      }
      case "FIN_DATE_CREATION": {
        this.filterForm.controls.finDateCreation.setValue(null);
        break;
      }
      case "LABORATOIRES": {
        if (filtre.value.length == 0) {
          filtre.value = null;
        }
        this.filterForm.controls.laboratoires.setValue(filtre.value);
        break;
      }
      case "MEDECINS": {
        if (filtre.value.length == 0) {
          filtre.value = null;
        }
        this.filterForm.controls.medecins.setValue(filtre.value);
        break;
      }
      case "EXAMENS": {
        if (filtre.value.length == 0) {
          filtre.value = null;
        }
        this.filterForm.controls.examens.setValue(filtre.value);
        break;
      }
      case "URGENT": {
        this.filterForm.controls.urgent.setValue(null);
        break;
      }
      case "PATHOLOGIE": {
        this.filterForm.controls.pathologique.setValue(null);
        break;
      }
      case "TERMINE": {
        this.filterForm.controls.termine.setValue(null);
        break;
      }
      case "PARTIELS": {
        this.filterForm.controls.partiels.setValue(null);
        break;
      }
      case "NOT-DOWNLOADED": {
        this.filterForm.controls.notdownloaded.setValue(null);
        break;
      }
      default:
        throw "Illegal argument";
    }
    let rechercheDossierDto = this.initRechercheDto();
    this.onFiltering.emit(rechercheDossierDto);
  }
}



// WEBPACK FOOTER //
// /home/vsts/work/1/s/digicerba-modules/digicerba-serveur-resultats/digicerba-serveur-resultats-web/src/angular/cerba/src/app/pages/cerba/pages/serveur-resultats/filtres/serveur-resultats-filtres.component.ts